import { Component, Input, Output, EventEmitter, ElementRef, ViewChildren, AfterViewInit, ViewChild, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, FormArray, FormBuilder, ValidatorFn, AbstractControl, FormControlName, Validators } from '@angular/forms';
import { ILookup, LookupList } from '../shared/lookup';
import { ClearanceItemService } from './clearance-item.service';
import { AppService } from '../app.service';
import { ClearanceItem, CIRestriction, CIDocument, CIImage, CITag, CISignedUrl } from './index';
import { SharedUtils, AppUtils } from '../shared/utils';
import { NotificationsService, Notification } from '../shared/helper-components/index'
import { ISubscription } from 'rxjs/Subscription';
import { PromptOptions, ModalPromptService } from '../shared/helper-components/modal-prompt.service';
@Component({
    selector: 'clearanceItem-tag',
    template: require('./clearance-item-tag.component.html')
})
export class ClearanceItemTagComponent implements OnDestroy {

    @ViewChild('tagSearchElement') public tagSearchElement: ElementRef;

    @Input('clearanceItemForm')
    public clearanceItemForm: FormGroup;
    @Input('globalTags')
    public globalTags: CITag[];
    @Input('isClearanceUser')
    public isClearanceUser: boolean = false;
    @Input('projectId')
    public projectId: string;
    @Input()
    public canTagsBeToggled: boolean = false;
    @Input()
    public preLoadTags: boolean = true;
    @Output() newTagAdded: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
    @Output() globalTagAdded: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
    @Output() customTagDeleted: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();

    tagSearchControl = new FormControl();
    tagSearchResult: ILookup[];
    autocompleteInit = {};
    constructor(
        private _clearanceItemService: ClearanceItemService,
        private fb: FormBuilder,
        private _notificationsService: NotificationsService,
        private _appService: AppService,
        private _prompt: ModalPromptService
    ) {
    }

    ngOnInit(): void {
        this.initItemForm();
        if (this.isClearanceUser) {
            this.processTagSearch();
        }
    }
    ngOnDestroy(): void {
        if (this.promptSubscription && !this.promptSubscription.closed) {
            this.promptSubscription.unsubscribe();
        }
    }
    loadTagLookups(): void {
        
        this._appService.retrieveCILookups(undefined, this.projectId, true)
            .subscribe(
                (list) => {
                    if (list) {
                        this.onLookupsRetrieved(list);
                    }
                },
                (error) => {
                    console.error('loadCILookups(...):' + error);
                }
            );

    }
    onLookupsRetrieved(list: LookupList[]): void {
        
        if (list && list.length > 0) {
            if (list.find(it => it.lookupType == 'Tags') != null) {
                var lookupData = list.find(it => it.lookupType == 'Tags').lookupData;
                if (lookupData) {
                    this.globalTags = [];
                    lookupData.forEach(lookup => {
                        var ciTag: CITag = new CITag();
                        ciTag.tagId = lookup.id;
                        ciTag.tagName = lookup.name;
                        ciTag.tagType = lookup.type;
                        ciTag.icon = 'bookmark';
                        this.globalTags.push(ciTag);
                    });

                    this.globalTags = AppUtils.SortTags(this.globalTags);

                    this.updateTagForm();
                }
            }

        }


    }

    get Tags(): FormArray {
        return <FormArray>this.clearanceItemForm.controls['tags'];
    }

    get SelectedTags(): FormArray {
        return <FormArray>this.clearanceItemForm.controls['selectedTags'];
    }

    updateTagForm(): void {

        let tags = <FormArray>this.clearanceItemForm.controls['tags'];

        if (tags && tags.controls && tags.controls.length > 0) {
            tags.controls = [];
        }

        if (this.globalTags)
            this.globalTags.forEach(tag => {
                const fb = this.initTag(tag);
                fb.patchValue(tag);
                tags.push(fb);
            });
    }

    updateTags(tags: CITag[]): void {
        this.globalTags = tags;
        this.updateTagForm();
    }

    getSelectedTags(): CITag[] {
        if (this.globalTags) {
            var itemToSave = <ClearanceItem>Object.assign({}, this.clearanceItemForm.value);
            if (itemToSave && itemToSave.tags)
                return itemToSave.tags.filter(it => it.isSelected);
        }
    }

    initItemForm(forceInit: boolean = false): void {

        if (!this.clearanceItemForm || forceInit)
            this.clearanceItemForm = this.fb.group({
                tags: this.fb.array([]),
            });
        if (this.preLoadTags)
            this.loadTagLookups();

    }
    public initTags(selected: boolean = false): FormGroup[] {
        var groups = [];
        if (this.globalTags)
            for (let tag of this.globalTags) {
                groups.push(this.initTag(tag));
            }
        return groups;

    }
    initTag(tag: CITag): FormGroup {
        return this.fb.group({
            id: tag.id,
            tagId: tag.tagId,
            tagName: tag.tagName,
            tagType: tag.tagType,
            icon: tag.icon,
            isSelected: tag.isSelected
        });

    }
    processTagSearch(): void {
        
        this._clearanceItemService.searchTerm(this.tagSearchControl.valueChanges, this.projectId)
            .subscribe(searchResults => {
                if (searchResults != null && searchResults.length > 0 && searchResults[0].lookupData) {
                    this.tagSearchResult = searchResults[0].lookupData;
                    console.log(this.tagSearchResult);
                    var tagNames: string = '';
                    for (let tag of this.tagSearchResult) {
                        tagNames = tagNames + '"' + tag.name + '": null,';
                    }
                    tagNames = tagNames.slice(0, -1);
                    tagNames = '{' + tagNames + '}';
                    var data = JSON.parse(tagNames);
                    this.autocompleteInit = {
                        'data': data,
                        onAutocomplete: (val) => {
                            this.selectSearchedTag(val);
                        },
                    };
                }
            });
    }

    selectSearchedTag(val: any): void {
        if (this.tagSearchResult != null && this.tagSearchResult.length > 0 && val) {
            var selectedTag = this.tagSearchResult.find(it => it.name == val);
            if (selectedTag && selectedTag.id) {
                this.addTagToGlobalIfNotExist(selectedTag.name, selectedTag.id, selectedTag.type);
            }
        }
    }

    addTagToGlobalIfNotExist(tagName: string, tagId: string, tagType: string) {
        if (tagName && this.globalTags) {
            var tagControl: FormGroup;
            var existingTag = this.Tags.controls.find(it => it.value.tagName.toUpperCase() == tagName.toUpperCase());
            if (existingTag) {
                //existingTag.isSelected:  true;
                //added the below to auto select the global tag if exists
                tagControl = this.Tags.controls.find(t => t.get('tagId').value == existingTag.value.tagId) as FormGroup;
                if (tagControl) {
                    tagControl.patchValue({ isSelected: true });
                }
            }
            else {
                var tag: CITag = new CITag();
                tag.tagId = tagId;
                tag.tagName = tagName;
                tag.isSelected = true;
                tag.tagType = tagType;
                tag.icon = 'bookmark';

                tagControl = this.initTag(tag);
                this.Tags.push(tagControl);

            }
            this.globalTagAdded.emit(tagControl);
        }

    }
    addCustomTag(value) {

        if (value) {
            this.addTagToGlobalIfNotExist(value, null, 'Custom');
            $('#tagSearchControl').val('');
            $('#tagSearchControl').focus();
            $('#tagSearchControl').select();
        }
    }
    togleTagSelection(tag: FormGroup): void {
        this.newTagAdded.emit(tag);
    }
    promptOptions: PromptOptions = { header: 'Delete Tag', body: '' };
    promptSubscription: ISubscription;
    deleteCustomTag(tag: FormGroup, event): void {  
        this.promptOptions.body = 'Are you sure you want to delete this Tag?';
            this.promptSubscription = this._prompt.openModal(null, true, this.promptOptions).first()
                .subscribe(
                    answerWasYes => {
                        if (answerWasYes) {
                            console.log('about to delete tag: ');
                            this.deleteCustomTagFromArray(tag);
                          
                        }
                    });  
        
        event.stopPropagation();
    }
    deleteCustomTagFromArray(tag: FormGroup): void {
        if (tag && tag.controls.tagType.value == 'Custom' && this.isClearanceUser) {
            
            var okToDelete: Boolean;
            //check if this is a recent tag that has not been assigned an id yet but it might have been entered before on this session.
            if (tag.controls.tagId.value == null) {
                this.customTagDeleted.next(tag)    ;         
            }
            else {
                 var ciID=  this.clearanceItemForm.controls["id"].value;
                //delete in server
                this._clearanceItemService.deleteCustomTag(ciID,tag.controls.tagId.value)
                    .subscribe(ret => {
                        if(ret)
                        this.customTagDeleted.next(tag);
                        else{
                            
                            this._notificationsService.add(new Notification('error', 'This tag used in other clearance items, please clear from other items, before deleting it.'));
                        }
                    } );
            }

            

        }
    }
   
    canTagBeChanged(): boolean {
        return this.isClearanceUser || this.canTagsBeToggled;
    }

}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/clearance-item/clearance-item-tag.component.ts